<template>
  <div
    :class="{
      navbar: true,
      'mob-fixed': $root.show_stickymenu && $root.show_stickymenu_mobile,
    }"
    id="navbar"
  >
    <template
      v-if="headerComponent.regulationBanner.enable_regulation_banner_sticky"
    >
      <div
        class="regulation-banner"
        v-if="headerComponent.regulationBanner.show_top_bar"
        id="sticky-regulation-banner"
      >
        <div class="container">
          <div class="regulation-banner-row">
            <div class="regulation-banner-text desk-reg">
              <span>{{ headerComponent.regulationBanner.heading }}</span>
            </div>
            <div
              class="regulation-banner-text mob-reg"
              v-if="
                headerComponent.regulationBanner
                  .show_regulation_banner_text_in_mobile
              "
            >
              <span>{{ headerComponent.regulationBanner.heading }}</span>
            </div>

            <div class="icons-column">
              <span
                class="icon-wrap"
                v-for="(icon, index) in headerComponent.regulationBanner.icons"
                :key="index"
              >
                <a v-if="icon.goto_link" :href="icon.goto_link" target="_blank">
                  <img
                    :src="icon.links"
                    :alt="icon.alt_text ? icon.alt_text : `Regulation Banner Icon ${index}`"
                    :width="icon.img_width || 'auto'"
                    :height="icon.img_height || 'auto'"
                  />
                </a>
                <img
                  v-else
                  :src="icon.links"
                  :alt="icon.alt_text ? icon.alt_text : `Regulation Banner Icon ${index}`"
                  :width="icon.img_width || 'auto'"
                  :height="icon.img_height || 'auto'"
                />
              </span>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div
        class="regulation-banner"
        v-if="headerComponent.regulationBanner.show_top_bar"
        id="regulation-banner"
        :style="{
          top: headerComponent.regulationBanner.enable_regulation_banner_sticky
            ? stickyRegulationBannerTop
            : '',
        }"
      >
        <div class="container">
          <div class="regulation-banner-row">
            <div class="regulation-banner-text desk-reg">
              <span>{{ headerComponent.regulationBanner.heading }}</span>
            </div>
            <div
              class="regulation-banner-text mob-reg"
              v-if="
                headerComponent.regulationBanner
                  .show_regulation_banner_text_in_mobile
              "
            >
              <span>{{ headerComponent.regulationBanner.heading }}</span>
            </div>

            <div class="icons-column">
              <span
                class="icon-wrap"
                v-for="(icon, index) in headerComponent.regulationBanner.icons"
                :key="index"
              >
                <a v-if="icon.goto_link" :href="icon.goto_link" target="_blank">
              <img
                    :src="icon.links"
                    :alt="icon.alt_text ? icon.alt_text : `Regulation Banner Icon ${index}`"
                    :width="icon.img_width || 'auto'"
                    :height="icon.img_height || 'auto'"
                  />
                </a>
                <img
                  v-else
                  :src="icon.links"
                  :alt="icon.alt_text ? icon.alt_text : `Regulation Banner Icon ${index}`"
                  :width="icon.img_width || 'auto'"
                  :height="icon.img_height || 'auto'"
                />
              </span>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template
      v-if="
        headerComponent.carnivalBanner &&
        Object.keys(headerComponent.carnivalBanner).length > 0 &&
        headerComponent.carnivalBanner.url &&
        headerComponent.carnivalBanner.enable_banner
      "
    >
      <a
        :href="headerComponent.carnivalBanner.url"
        :target="headerComponent.carnivalBanner.link_target"
        :rel="headerComponent.carnivalBanner.link_rel"
      >
        <div
          class="carnival-banner"
          id="carnival-banner"
          v-if="
            headerComponent.carnivalBanner &&
            Object.keys(headerComponent.carnivalBanner).length > 0
          "
          :style="{
            background: `url('${headerComponent.carnivalBanner.background_image}') no-repeat,
          ${headerComponent.carnivalBanner.background_color}`,
          }"
        >
          <span
            :class="{
              'first-text custom-font-1': true,
              'text-white': !getContrastYIQ(
                headerComponent.carnivalBanner.background_color
              ),
              'text-gray': getContrastYIQ(
                headerComponent.carnivalBanner.background_color
              ),
            }"
            >{{ headerComponent.carnivalBanner.banner_text }}</span
          >
          <!--<span class="sec-text">Sub Header</span>-->
        </div>
      </a>
    </template>
    <template v-else>
      <div
        class="carnival-banner"
        id="carnival-banner"
        v-if="
          headerComponent.carnivalBanner &&
          Object.keys(headerComponent.carnivalBanner).length > 0 &&
          headerComponent.carnivalBanner.enable_banner
        "
        :style="{
          background: `url('${headerComponent.carnivalBanner.background_image}') no-repeat,
          ${headerComponent.carnivalBanner.background_color}`,
        }"
      >
        <span
          :class="{
            'first-text custom-font-1': true,
            'text-white': !getContrastYIQ(
              headerComponent.carnivalBanner.background_color
            ),
            'text-gray': getContrastYIQ(
              headerComponent.carnivalBanner.background_color
            ),
          }"
          >{{ headerComponent.carnivalBanner.banner_text }}</span
        >
        <!--<span class="sec-text">Sub Header</span>-->
      </div>
    </template>
    <header
      id="header"
      :class="{
        'mobile-menu-open': mobileMenuOpen,
        'mobile-menu-close': !mobileMenuOpen,
      }"
      :style="{ 'background-color': $root.color_schema.primary }"
    >
      <div class="container">
        <div id="cssmenu" class="cssmenu">
          <div class="logo">
            <template v-if="$root.enable_piwik_reload">
              <a href="/" class="log-img">
                <img
                  :src="headerComponent.logo"
                  :alt="siteName"
                  width="130"
                  height="52"
                />
              </a>
            </template>
            <template v-else>
              <router-link to="/" class="log-img">
                <img
                  :src="headerComponent.logo"
                  :alt="siteName"
                  width="130"
                  height="52"
                />
              </router-link>
            </template>
          </div>
          <div id="head-mobile"></div>
          <ul
            id="header-content"
            :style="{ '--primary-color': $root.color_schema.primary }"
            v-if="headerComponent.menus"
          >
            <NavMenu
              v-for="menu in headerComponent.menus"
              :key="menu.ID"
              :menu="menu"
            ></NavMenu>
            <li
              class="search-wrapper"
              :style="{ '--primary-color': $root.color_schema.primary }"
            >
              <span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                  fill="none"
                  class="src-icon"
                >
                  <path
                    opacity="0.6"
                    d="M11.6881 10.1168L8.918 7.38291C9.56287 6.3991 9.81949 5.21593 9.6392 4.05779C9.45891 2.89966 8.85425 1.84708 7.93989 1.09968C7.02553 0.352278 5.86505 -0.0379789 4.67852 0.00291729C3.49198 0.0438135 2.36192 0.513019 1.50261 1.32155C0.64331 2.13009 0.114528 3.22173 0.0165455 4.38946C-0.0814373 5.55719 0.258192 6.7198 0.971027 7.65682C1.68386 8.59385 2.72033 9.24012 3.88388 9.47308C5.04744 9.70605 6.25716 9.50951 7.28364 8.92072L10.0538 11.6546C10.2604 11.8685 10.5446 11.9926 10.844 11.9997C11.1434 12.0067 11.4333 11.8961 11.65 11.6922C11.8668 11.4883 11.9925 11.2077 11.9997 10.9123C12.0068 10.6168 11.8948 10.3307 11.6881 10.1168ZM1.54949 4.80623C1.544 4.15489 1.73469 3.51661 2.09736 2.9724C2.46003 2.42819 2.97834 2.00258 3.5865 1.74956C4.19467 1.49654 4.86529 1.42752 5.51327 1.55126C6.16125 1.67501 6.75737 1.98593 7.22601 2.44459C7.69464 2.90325 8.01466 3.48896 8.14545 4.12741C8.27624 4.76586 8.21191 5.42826 7.96063 6.03056C7.70934 6.63287 7.28242 7.14793 6.73405 7.51039C6.18567 7.87285 5.54056 8.06636 4.88056 8.06639C4.00244 8.06464 3.16038 7.72145 2.53686 7.11121C1.91335 6.50097 1.5586 5.67282 1.54949 4.80623Z"
                    fill="#030030"
                  />
                </svg>
                <input
                  type="search"
                  :placeholder="$root.i18n.search"
                  v-model="searchText"
                  @keyup.enter="searchItem"
                />
              </span>
            </li>
          </ul>
          <template
            v-if="
              headerComponent.menus &&
              headerComponent.menus.length > 0
            "
          >
            <HeaderMobMenu
              :menus="headerComponent.menus"
              :regulationBanner="
                headerComponent.regulationBanner.show_top_bar &&
                regulationBanner
                  ? true
                  : false
              "
              :regulationBannerSticky="
                headerComponent.regulationBanner
                  .enable_regulation_banner_sticky && regulationBanner
                  ? true
                  : false
              "
              :carnivalBanner="
                headerComponent.carnivalBanner.enable_banner && carnivalBanner
                  ? true
                  : false
              "
              @menuOpen="menuOpen"
            />
          </template>
        </div>
      </div>
    </header>
    <header
      v-if="$root.show_stickymenu && $root.show_stickymenu_desktop"
      id="sticky-header"
      class="sticky-header"
      :style="{
        'background-color': $root.color_schema.primary,
      }"
    >
      <div class="container">
        <div id="cssmenu" class="cssmenu">
          <div class="logo">
            <template v-if="$root.enable_piwik_reload">
              <a href="/" class="log-img">
                <img
                  :src="headerComponent.logo"
                  :alt="siteName"
                  width="130"
                  height="52"
                />
              </a>
            </template>
            <template v-else>
              <router-link to="/" class="log-img">
                <img
                  :src="headerComponent.logo"
                  :alt="siteName"
                  width="130"
                  height="52"
                />
              </router-link>
            </template>
          </div>
          <div id="head-mobile"></div>
          <ul
            :style="{ '--primary-color': $root.color_schema.primary }"
            v-if="headerComponent.menus"
          >
            <NavMenu
              v-for="menu in headerComponent.menus"
              :key="menu.ID"
              :menu="menu"
            ></NavMenu>
            <li
              class="search-wrapper"
              :style="{ '--primary-color': $root.color_schema.primary }"
            >
              <span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                  fill="none"
                  class="src-icon"
                >
                  <path
                    opacity="0.6"
                    d="M11.6881 10.1168L8.918 7.38291C9.56287 6.3991 9.81949 5.21593 9.6392 4.05779C9.45891 2.89966 8.85425 1.84708 7.93989 1.09968C7.02553 0.352278 5.86505 -0.0379789 4.67852 0.00291729C3.49198 0.0438135 2.36192 0.513019 1.50261 1.32155C0.64331 2.13009 0.114528 3.22173 0.0165455 4.38946C-0.0814373 5.55719 0.258192 6.7198 0.971027 7.65682C1.68386 8.59385 2.72033 9.24012 3.88388 9.47308C5.04744 9.70605 6.25716 9.50951 7.28364 8.92072L10.0538 11.6546C10.2604 11.8685 10.5446 11.9926 10.844 11.9997C11.1434 12.0067 11.4333 11.8961 11.65 11.6922C11.8668 11.4883 11.9925 11.2077 11.9997 10.9123C12.0068 10.6168 11.8948 10.3307 11.6881 10.1168ZM1.54949 4.80623C1.544 4.15489 1.73469 3.51661 2.09736 2.9724C2.46003 2.42819 2.97834 2.00258 3.5865 1.74956C4.19467 1.49654 4.86529 1.42752 5.51327 1.55126C6.16125 1.67501 6.75737 1.98593 7.22601 2.44459C7.69464 2.90325 8.01466 3.48896 8.14545 4.12741C8.27624 4.76586 8.21191 5.42826 7.96063 6.03056C7.70934 6.63287 7.28242 7.14793 6.73405 7.51039C6.18567 7.87285 5.54056 8.06636 4.88056 8.06639C4.00244 8.06464 3.16038 7.72145 2.53686 7.11121C1.91335 6.50097 1.5586 5.67282 1.54949 4.80623Z"
                    fill="#030030"
                  />
                </svg>
                <input
                  type="search"
                  :placeholder="$root.i18n.search"
                  v-model="searchText"
                  @keyup.enter="searchItem"
                />
              </span>
            </li>
          </ul>
        </div>
      </div>
    </header>
  </div>
</template>

<script>
import NavMenu from "@/components/ui/NavMenu.vue";
import HeaderMobMenu from "@/components/layouts/HeaderMobMenu/HeaderMobMenu";
import router from "@/router";
import { pSBC, getContrastYIQ } from "@/misc/misc-function";

export default {
  name: "Header",
  components: {
    NavMenu,
    HeaderMobMenu,
  },
  data: function () {
    return {
      searchText: "",
      siteName: wpvue_script_data_params.site_name,
      regulationBanner: true,
      carnivalBanner: true,
      regulationBannerHeight: 0,
      carnivalBannerHeight: 0,
      mobileMenuOpen: false,
      stickyHeaderTop: 0,
      stickyRegulationBannerTop: 0,
    };
  },
  props: {
    headerComponent: {
      regulationBanner: {},
      carnivalBanner: {},
      menus: [],
      logo: "",
    },
  },
  created: function () {
    if (this.$route.name === "search") {
      this.searchText = this.$route.params.searchText;
    }
  },
  mounted: function () {
    this.$nextTick(() => {
      if (document.getElementById("regulation-banner")) {
        this.regulationBannerHeight =
          document.getElementById("regulation-banner").clientHeight;
      }
    });
    window.addEventListener(
      "scroll",
      () => {
        let element = document.getElementById("regulation-banner");
        if (element && this.regulationBannerHeight <= 0) {
          this.regulationBannerHeight = element.clientHeight;
        }
        if (element && (!document.querySelectorAll(".background-logo-small") || window.innerWidth < 1240)) {
          let scTop = window.pageYOffset || document.documentElement.scrollTop;
          if (scTop > 10) {
            element.style.height = 0;
            element.style.padding = "0";
            element.style.display = "none";
            if (
              this.$root.show_stickymenu &&
              this.$root.show_stickymenu_mobile &&
              window.innerWidth < 992
            ) {
              document.body.style.paddingTop = "80px";
            }
          } else {
            element.style.height = `${this.regulationBannerHeight}px`;
            element.style.padding = "10px 0";
            element.style.display = "block";
            if (
              this.$root.show_stickymenu &&
              this.$root.show_stickymenu_mobile &&
              window.innerWidth < 992
            ) {
              if (scTop === 0) {
                document.body.style.paddingTop = `${
                  this.regulationBannerHeight + 80
                }px`;
              } else {
                document.body.style.paddingTop = "80px";
              }
            }
          }
        }

        //Sticky regulation banner
        let elementSty = document.getElementById("sticky-regulation-banner");
        if (elementSty) {
          let scTopsty =
            window.pageYOffset || document.documentElement.scrollTop;
          if (scTopsty > 10) {
            if (
              this.headerComponent.regulationBanner
                .enable_regulation_banner_sticky
            ) {
              elementSty.classList.add("sticky-regulation-banner");

              elementSty.style.height = `${elementSty.offsetHeight}px`;
              elementSty.style.padding = "10px 0";
              elementSty.style.display = "block";
            } else {
              elementSty.style.height = 0;
              elementSty.style.padding = "0";
              elementSty.style.display = "none";
            }
            if (
              this.$root.show_stickymenu &&
              this.$root.show_stickymenu_mobile &&
              window.innerWidth < 992
            ) {
              if (document.getElementById("header")) {
                document.getElementById(
                  "header"
                ).style.top = `${elementSty.offsetHeight}px`;
                document.body.style.paddingTop = `${
                  elementSty.offsetHeight + 80
                }px`;
              } else {
                document.body.style.paddingTop = "80px";
              }
            }
          } else {
            if (
              this.headerComponent.regulationBanner
                .enable_regulation_banner_sticky
            ) {
              elementSty.classList.remove("sticky-regulation-banner");
            }
            elementSty.style.height = `${elementSty.offsetHeight}px`;
            elementSty.style.padding = "10px 0";
            elementSty.style.display = "block";
            if (
              this.$root.show_stickymenu &&
              this.$root.show_stickymenu_mobile &&
              window.innerWidth < 992
            ) {
              if (scTopsty === 0) {
                document.body.style.paddingTop = `${
                  elementSty.offsetHeight + 80
                }px`;
              } else {
                document.body.style.paddingTop = `${
                  elementSty.offsetHeight + 80
                }px`;
              }
              elementSty.style.top = "0px";
              if (document.getElementById("header"))
                document.getElementById("header").style.top = "0px";
            }
          }
        }

        // Admin Bar checking
        if (document.getElementById("panel-wrapper")) {
          if (document.getElementById("review-sticky-card")) {
            if (window.pageYOffset >= 338) {
              if (document.getElementById("sticky-header")) {
                document.getElementById("sticky-header").style.top = `${
                  document.getElementById("panel-wrapper").offsetHeight +
                  document.getElementById("review-sticky-card").offsetHeight
                }px`;
              }
            } else {
              if (document.getElementById("sticky-header"))
                document.getElementById("sticky-header").style.top = `${
                  document.getElementById("panel-wrapper").offsetHeight
                }px`;
            }
          } else {
            if (document.getElementById("sticky-header"))
              document.getElementById("sticky-header").style.top = `${
                document.getElementById("panel-wrapper").offsetHeight
              }px`;
          }
        } else {
          if (document.getElementById("sticky-regulation-banner")) {
            if (document.getElementById("sticky-header"))
              document.getElementById("sticky-header").style.top = `${
                document.getElementById("sticky-regulation-banner").offsetHeight
              }px`;
          } else {
            if (document.getElementById("sticky-header"))
              document.getElementById("sticky-header").style.top = "0px";
          }
        }

        if (document.getElementById("sticky-header")) {
          let scrollDist =
            window.pageYOffset || document.documentElement.scrollTop;
          if (scrollDist > 10 && window.innerWidth > 991) {
            document.getElementById("sticky-header").style.display = "block";
          } else {
            document.getElementById("sticky-header").style.display = "none";
          }
        }
      },
      { passive: true }
    );
  },
  methods: {
    pSBC,
    getContrastYIQ,
    searchItem: function () {
      router
        .push({ name: "search", params: { searchText: this.searchText } })
        .catch((err) => {});
    },
    menuOpen: function (val) {
      this.mobileMenuOpen = val;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
@import "~@/assets/less/base/variable";

.search-wrapper {
  display: flex !important;
  background-color: var(--primary-color);
  span {
    flex: 1;
  }
}

#header {
  background-color: var(--primary-color);
}

#header-content {
  display: none;
  background-color: var(--primary-color);
  @media (min-width: @sizes[large]) {
    display: block;
  }
}

.regulation-banner {
  display: block;
  position: relative;
  overflow: hidden;
  z-index: 9;
  padding: 10px 0;
  background: #fcfcfc;
  -webkit-transition: all 0.6s ease-in-out;
  -o-transition: all 0.6s ease-in-out;
  transition: all 0.6s ease-in-out;
  &-row {
    height: 100%;
    display: flex;
    @media (max-width: @sizes[small]) {
      flex-wrap: wrap;
    }
  }
  &-text {
    font-size: 12px;
    line-height: 20px;
    margin-bottom: 6px;
    display: none;
    @media (min-width: @sizes[small]) {
      flex: 1;
      margin-bottom: 0;
    }
    @media (min-width: @sizes[large]) {
      display: block;
    }
  }
  .icons-column {
    flex: 1;
    display: flex;
    justify-content: space-around;
    max-height: 40px;
    @media (min-width: @sizes[large]) {
      justify-content: flex-end;
    }
    img {
      height: 32px;
      max-width: 100%;
    }
    a > img {
      height: 32px;
      max-width: 100%;
    }
  }
}

.desk-reg {
  display: none;
  @media (min-width: @sizes[small]) {
    display: block;
  }
}

.mob-reg {
  display: block;
  width: 100%;
  @media (min-width: @sizes[small]) {
    display: none;
  }
}

header {
  position: relative;
  width: 100%;
  background: @darkblue;
  padding: 10px 0;
  min-height: 60px;
  z-index: 9;
  @media (min-width: @sizes[tablet]) {
    padding: 0;
    min-height: auto;
  }
}
.logo {
  position: relative;
  z-index: 123;
  padding: 15px;
  padding-left: 0;
  font: 18px verdana;
  color: #6ddb07;
  float: none;
  width: 100%;
  text-align: center;
  cursor: pointer;
  a {
    color: #6ddb07;
    display: inline-block;
  }
  padding: 0;
  @media (min-width: @sizes[tablet]) {
    padding: 4px 23px 4px 0;
    padding-left: 0;
  }
}

.cssmenu {
  z-index: 100;
  background: inherit;
  border: 0;
  list-style: none;
  line-height: 1;
  display: block;
  position: relative;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  font-family: var(--default-regular);

  ul {
    float: right;
    border: 0;
    list-style: none;
    line-height: 1;
    display: block;
    position: relative;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    li {
      border: 0;
      list-style: none;
      line-height: 1;
      display: block;
      position: relative;
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
      box-sizing: border-box;
      a {
        border: 0;
        list-style: none;
        line-height: 1;
        display: block;
        position: relative;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        font-family: var(--default-regular);
        font-weight: normal;
        position: relative;
        input {
          font-family: var(--default-regular);
          position: relative;
          width: 100%;
          border-radius: 10px !important;
          padding: 4px;
          text-indent: 26px;
          display: inline-block;
          border: none;
          &:hover {
            border-radius: 10px !important;
          }
          &:focus {
            border-radius: 10px !important;
          }
          @media (min-width: @sizes[tablet]) {
            width: 87px;
          }
        }
      }
      span {
        border: 0;
        list-style: none;
        line-height: 1;
        display: block;
        position: relative;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        font-family: var(--default-regular);
        font-weight: normal;
        position: relative;
        input {
          font-family: var(--default-regular);
          position: relative;
          width: 100%;
          border-radius: 10px !important;
          padding: 4px;
          text-indent: 26px;
          display: inline-block;
          border: none;
          &:hover {
            border-radius: 10px !important;
          }
          &:focus {
            border-radius: 10px !important;
          }
          @media (min-width: @sizes[tablet]) {
            width: 87px;
          }
        }
      }
    }
    li.active {
      a {
        color: #fff;
        opacity: 1;
      }
      &:hover {
        -webkit-transition: background 0.3s ease;
        -ms-transition: background 0.3s ease;
        transition: background 0.3s ease;
      }
      -webkit-transition: background 0.3s ease;
      -ms-transition: background 0.3s ease;
      transition: background 0.3s ease;
    }
    li.has-sub.active {
      -webkit-transition: background 0.3s ease;
      -ms-transition: background 0.3s ease;
      transition: background 0.3s ease;
    }
    ul {
      position: absolute;
      left: -9999px;
      li {
        height: 0;
        -webkit-transition: all 0.25s ease;
        -ms-transition: all 0.25s ease;
        background: #333;
        transition: all 0.25s ease;
        a {
          border-bottom: 1px solid rgba(150, 150, 150, 0.15);
          padding: 11px 15px;
          width: 170px;
          font-size: 12px;
          text-decoration: none;
          color: #ddd;
          font-weight: 400;
          &:hover {
            color: #fff;
          }
        }
        &:last-child {
          > a {
            border-bottom: 0;
          }
        }
        &:hover {
          > a {
            color: #fff;
          }
        }
        span {
          border-bottom: 1px solid rgba(150, 150, 150, 0.15);
          padding: 11px 15px;
          width: 170px;
          font-size: 12px;
          text-decoration: none;
          color: #ddd;
          font-weight: 400;
          &:hover {
            color: #fff;
          }
        }
        &:last-child {
          > span {
            border-bottom: 0;
          }
        }
        &:hover {
          > span {
            color: #fff;
          }
        }
      }
      ul {
        margin-left: 100%;
        top: 0;
        li.active {
          a {
            border-left: 1px solid #222222;
          }
        }
      }
      li.last-item {
        > a {
          border-bottom: 0;
        }
      }
      li.has-sub {
        &:hover {
          background: #363636;
        }
      }
      > li.has-sub {
        &:hover {
          > a {
            &:before {
              top: 17px;
              height: 0;
            }
          }
        }
      }
    }
    li.has-sub {
      ul {
        li.has-sub {
          ul {
            li {
              &:hover {
              }
            }
          }
        }
      }
    }
  }

  #head-mobile {
    border: 0;
    list-style: none;
    line-height: 1;
    display: block;
    position: relative;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    display: none;
  }
  &:after {
    content: ".";
    display: block;
    clear: both;
    visibility: hidden;
    line-height: 0;
    height: 0;
  }
  > ul {
    &:after {
      content: ".";
      display: block;
      clear: both;
      visibility: hidden;
      line-height: 0;
      height: 0;
    }
    > li {
      float: left;
      &:last-child {
        a {
          position: relative;
          margin-top: 15px;
          margin-left: 20px;
          line-height: 1.2;
          @media (min-width: @sizes[tablet]) {
            margin-left: 10px;
          }
          @media (min-width: @sizes[md-large]) {
            margin-left: 60px;
          }
          @media (min-width: @sizes[extra-large]) {
            margin-left: 80px;
          }
          &:hover {
            border-radius: 10px !important;
          }
          &:before {
            position: absolute;
            left: 7px;
            content: "";
            top: 7px;
            background: var(--search-icon) no-repeat;
            width: 12px;
            height: 12px;
            z-index: 1;
          }
        }
        span {
          position: relative;
          margin-top: 15px;
          margin-left: 20px;
          line-height: 1.2;
          @media (min-width: @sizes[tablet]) {
            margin-left: 10px;
          }
          @media (min-width: @sizes[md-large]) {
            margin-left: 60px;
          }
          @media (min-width: @sizes[extra-large]) {
            margin-left: 50px;
          }
          &:hover {
            border-radius: 10px !important;
          }
        }
      }
      > a {
        margin: 20px;
        font-size: 15px;
        letter-spacing: 0;
        text-decoration: none;
        opacity: 0.7;
        color: @white;
        font-family: var(--default-regular);
        font-weight: 300;
        @media (min-width: @sizes[tablet]) {
          margin: 30px 10px;
          font-size: 14px;
        }
        @media (min-width: @sizes[md-large]) {
          margin: 30px 20px;
          font-size: 15px;
        }
        &:last-child {
          background-color: transparent;
          border: none;
          border-radius: 10px;
          opacity: 1;
          display: flex;
          @media (min-width: @sizes[tablet]) {
            margin-right: 0;
            display: block;
          }
          &:hover {
            border-radius: 10px;
          }
        }
        img {
          display: inline-block;
          max-width: 100%;
          height: auto;
          vertical-align: bottom;
          margin-right: 10px;
          @media (min-width: @sizes[tablet]) {
            margin-right: 5px;
          }
          @media (min-width: @sizes[md-large]) {
            margin-right: 10px;
          }
        }
      }
      &:hover {
        > a {
          color: @white;
          opacity: 1;
        }
        img {
          color: #fff;
        }
      }
    }
    > li.has-sub {
      > a {
        padding-right: 30px;
        &:after {
          position: absolute;
          top: 22px;
          right: 11px;
          width: 8px;
          height: 2px;
          display: block;
          background: #ddd;
          content: "";
        }
        &:before {
          position: absolute;
          top: 19px;
          right: 14px;
          display: block;
          width: 2px;
          height: 8px;
          background: #ddd;
          content: "";
          -webkit-transition: all 0.25s ease;
          -ms-transition: all 0.25s ease;
          transition: all 0.25s ease;
        }
      }
      &:hover {
        > a {
          &:before {
            top: 23px;
            height: 0;
          }
        }
      }
      > ul {
        > li.active {
          > a {
            border-top: 1px solid #333;
          }
        }
      }
    }
    ul {
      > li.has-sub {
        > ul {
          > li.active {
            > a {
              border-top: 1px solid #333;
            }
          }
        }
      }
    }
  }
  li {
    &:hover {
      > ul {
        left: auto;
        > li {
          height: 35px;
        }
      }
    }
  }
}

@media (min-width: @sizes[large]) {
  .logo {
    float: left;
    width: 14%;
  }
}

input[type="search"]::-webkit-input-placeholder {
  line-height: 20px;
}

/* placeholder */

::-webkit-input-placeholder {
  /* Chrome/Opera/Safari */
  font-size: 12px;
  font-style: normal;
  font-family: var(--default-regular);
  position: absolute;
  top: 3px;
}
::-moz-placeholder {
  /* Firefox 19+ */
  font-size: 12px;
  font-style: normal;
  font-family: var(--default-regular);
  position: absolute;
  top: 3px;
}
:-ms-input-placeholder {
  /* IE 10+ */
  font-size: 12px;
  font-style: normal;
  font-family: var(--default-regular);
  position: absolute;
  top: 3px;
}
:-moz-placeholder {
  /* Firefox 18- */
  font-size: 12px;
  font-style: normal;
  font-family: var(--default-regular);
  position: absolute;
  top: 3px;
}

.cssmenu ul {
  left: -20px;
  right: -20px;
  @media (min-width: @sizes[tablet]) {
    left: -15px;
    right: -15px;
  }
}

.icon-wrap {
  margin-left: 10px;
  display: inline-flex;
  align-items: center;
}

.sticky-header {
  position: fixed;
  display: none;
  z-index: 999990;
  .logo {
    padding: 11px 23px 11px 0;
  }
  .search-wrapper {
    span {
      margin: 19px 0 17px 10px !important;
      @media (min-width: @sizes[md-large]) {
        margin: 19px 0 17px 50px !important;
      }
    }
  }
}

.regulation-banner-sticky {
  position: fixed;
  display: none;
  z-index: 999990;
}

.mob-fixed {
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 9999;
  @media (min-width: @sizes[large]) {
    position: relative;
  }
}

.src-icon {
  position: absolute;
  left: 8px;
  z-index: 10;
  top: 8px;
}

.logo {
  .log-img {
    width: 130px;
    height: 52px;
    img {
      width: 130px;
      height: 52px;
    }
  }
}

.carnival-banner {
  height: 45px;
  //text-align: center;
  line-height: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-position: center !important;
  position: relative;
  z-index: 7;

  .first-text {
    display: block;
    font-size: 18px;
    color: @white;
    @media (max-width: @sizes[small]) {
      padding: 10px;
    }
  }
  .sec-text {
    display: block;
    font-size: 18px;
  }
}

.sticky-regulation-banner {
  //bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  position: fixed;
  //color: @white;
}

@media (min-width: @sizes[large]) {
  .d-md-none {
    display: none;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/layouts/Header.vue